import React, { useEffect, useRef, useState } from 'react';
import SimplePeer from 'simple-peer';

const Participant = () => {
  const [roomId, setRoomId] = useState('');
  const [connected, setConnected] = useState(false);
  const [error, setError] = useState('');
  const audioRef = useRef(null);
  const ws = useRef(null);

  const handleRoomIdChange = (e) => {
    setRoomId(e.target.value);
  };

  const joinStream = () => {
    if (!roomId) {
      setError('Please enter a valid room ID.');
      return;
    }

    const wsUrl = `wss://apps.pluglr.com/ws/stream/start/live/${roomId}`; // Dynamic WebSocket URL for participants
    ws.current = new WebSocket(wsUrl);

    ws.current.onopen = () => {
      ws.current.send(JSON.stringify({ type: 'join-request', eventId: roomId }));
    };

    ws.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      const { type, signal } = data;

      if (type === 'offer') {
        const peer = new SimplePeer({
          initiator: false,
          trickle: false,
          config: {
            iceServers: [
              {
                urls: 'stun:stun.l.google.com:19302', // Google's public STUN server
              },
            ],
          },
        });

        peer.on('signal', (answerSignal) => {
          ws.current.send(JSON.stringify({ type: 'answer', signal: answerSignal }));
        });

        peer.on('stream', (stream) => {
          if (audioRef.current) {
            audioRef.current.srcObject = stream;
            audioRef.current.play();
            setConnected(true);
          }
        });

        peer.signal(signal);
      }
    };

    ws.current.onerror = () => {
      setError('Unable to connect to the stream. Please check the room ID.');
    };
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">
        {connected ? 'Connected 🎧 Listening...' : 'Enter Room ID to Join Stream'}
      </h1>

      {!connected && (
        <div className="my-4">
          <input
            type="text"
            value={roomId}
            onChange={handleRoomIdChange}
            className="p-2 border rounded"
            placeholder="Enter room ID here"
          />
          <button
            onClick={joinStream}
            className="ml-2 p-2 bg-blue-500 text-white rounded"
          >
            Join Stream
          </button>
        </div>
      )}

      {error && <p className="text-red-500">{error}</p>}

      {connected && <audio ref={audioRef} autoPlay controls />}
    </div>
  );
};

export default Participant;
